export const isAlphanumeric = (str: string) => {

    const regex = new RegExp('/^[a-z0-9]+$/i');

    return regex.test(str);
}

export const isAlphaNumeric = (str: string): boolean => {

    const regex = new RegExp("^[a-zA-Z0-9 ]*$");
    // const regex = new RegExp(/^[\w\-\s]+$/);

    // const tempArr = str.split(" ");

    // console.log("tempArr", tempArr);


    // tempArr.forEach((word: any) => {
    //     if (regex.test(word)) {
    //         // console.log("run");
    //     } else {
    //         // console.log("stop");
    //         return false
    //     }
    // })

    console.log("reg", regex.test(str));


    return regex.test(str)
}

export const isValidEmail = (email:string) => {
    return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
}